import React, { useContext } from "react";
import PropTypes from "prop-types";
import parse from "html-react-parser";
import { SimpleContext } from "../../../../../../store/context/simple-context";
import { formatNumber } from "../../../../../../helpers";
import "./index.scss";

const Pay = ({ discount, price, cents, period }) => {
  const {
    translate: { t },
  } = useContext(SimpleContext);

  return (
    <p className="GP-C-SB-T-P">
      {discount && (
        <span className="GP-C-SB-T-P-discount">
          {`$${formatNumber(t("language code"), discount.price)}`}
          <sup>{discount.cents}</sup>
        </span>
      )}
      <span className="GP-C-SB-T-P-price">
        {`$${price.toLocaleString(t("language code"), { useGrouping: true })}`}
        {cents && <sup>{cents}</sup>}
        <span className="GP-C-SB-T-P__period">{parse(t(period))}</span>
      </span>
    </p>
  );
};

Pay.propTypes = {
  discount: PropTypes.object,
  price: PropTypes.number,
  cents: PropTypes.number,
  period: PropTypes.string,
};

export default Pay;
